// RouteAnalytics — one $pageview per client-side route change.
//
// posthog-js's capture_pageview only fires on the initial document load.
// Parcely is a single-page app, so /pricing, /app, /settings and the learn
// pages reached through the router never produced a pageview; the funnel
// could not tell how many signed-in users ever saw /pricing. Mount once,
// inside the router. The first render is skipped on purpose: the SDK's own
// load-time pageview already covers it.

import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { capture } from "../lib/analytics";

const RouteAnalytics: React.FC = () => {
  const { pathname, search } = useLocation();
  const first = useRef(true);
  useEffect(() => {
    if (first.current) {
      first.current = false;
      return;
    }
    capture("$pageview", { $current_url: window.location.href, $pathname: pathname });
    // search is a dependency so a same-path query change (e.g. ?county=)
    // is a new view; it is deliberately not sent as a property.
  }, [pathname, search]);
  return null;
};

export default RouteAnalytics;
